export default __webpack_public_path__ + "static/media/banner_sgk_canh_dieu.6d7daf93.png";